// extracted by mini-css-extract-plugin
module.exports = {"infoButton":"ContactlessDeliveryInstructions__infoButton___1Z6ux TermsModal__infoButton___gzuhE"};